import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";

@Component({
  selector: "plants-primary-nav",
  imports: [RouterModule],
  templateUrl: "./plants-primary-nav.component.html",
  styleUrls: ["./plants-primary-nav.component.scss"]
})
export class PlantsPrimaryNavComponent {}
